<ng-container *ngIf="control.errors && (control.dirty || control.touched)">
    <ng-container *ngFor="let validationError of validationErrors">
        <span *ngIf="!!this.control.errors[validationError.name]" [class.d-block]="!!this.control.errors[validationError.name]" class="error invalid-feedback">
            {{ getValidationErrorMessage(validationError) }}
        </span>
    </ng-container>
</ng-container>
